<h2 mat-dialog-title>Critical Date Actions</h2>

<mat-dialog-content>
  <p><strong>{{ data.criticalDate.name || 'Important Date' }}</strong></p>
  <p class="date-type">{{ data.criticalDate.type }}</p>
  @if (data.criticalDate.eventDate) {
    <p class="event-date">Event Date: {{ data.criticalDate.eventDate | date: 'mediumDate' }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onEditClick()" [disabled]="isViewer()">
    Edit Date
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="onGoToItemClick()"
    [disabled]="!data.hasEntityLink">
    Go To Item
  </button>
  <button mat-button (click)="onCancelClick()">
    Cancel
  </button>
</mat-dialog-actions>
